import classnames from 'classnames';
import _ from 'lodash';

type SetOfClassnames = { [key: string]: string };

export const mergeClassnames = (base: SetOfClassnames, additional: SetOfClassnames) => {
  const result: SetOfClassnames = {};
  _.forEach(
    base,
    (value: string, key: string) => result[key] = classnames(value, additional[key])
  );

  return result;
};
